import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { DeliveryZone } from 'src/redux/delivery/types';
import type { DeliverySettingsAPIDeliveryZone } from 'src/services/delivery-settings/types/DeliverySettingsAPIDeliveryZone';

export const adaptDeliverySettingsToState = (
  deliveryZoneOptions: DeliverySettingsAPIDeliveryZone[],
  userCurrencyCode: CurrencyCode,
): DeliveryZone[] => {
  return deliveryZoneOptions.map((zone) => {
    return {
      zoneCode: zone.zoneCode,
      deliveryOptions: zone.deliveryOptions.map((option) => {
        const { productCodes, ...restOfOption } = option;
        const userCurrencyPrice = restOfOption.prices.find(
          (price) => price.currencyCode === userCurrencyCode,
        )!;

        return {
          ...restOfOption,
          price: userCurrencyPrice,
        };
      }),
      groupingCode: zone.groupingCode,
    };
  });
};
